import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Cursor from '@/ui/Cursor';

import Footer from './Footer';
import Nav from './Nav';

export default function Shell() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Cursor />
      <span className="regmark tl" aria-hidden="true" />
      <span className="regmark tr" aria-hidden="true" />
      <span className="regmark bl" aria-hidden="true" />
      <span className="regmark br" aria-hidden="true" />
      <div className="rail rail-l" aria-hidden="true">
        <span>MOCT / TRANSMISSION / 2026</span>
      </div>
      <div className="rail rail-r" aria-hidden="true">
        <span>YEREVAN / 40.18°N / 44.51°E</span>
      </div>

      <Nav />
      <main className="shell">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
